import React from "react";

// Custom Confirmation Modal for Support System
const SupportConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Yes, Delete",
  cancelText = "No, Cancel",
  loading = false,
  loadingText = "Deleting...",
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-card border border-border/70 p-6 rounded-lg shadow-xl w-96 max-w-[90vw] relative">
        <button
          className="absolute top-4 right-4 text-muted-foreground hover:text-foreground text-xl font-medium transition-colors"
          onClick={onClose}
          disabled={loading}
          aria-label="Close"
        >
          ×
        </button>
        <h3 className="text-base font-semibold text-foreground mb-4 pr-8">
          {title}
        </h3>
        <div className="space-y-5">
          <p className="text-sm text-muted-foreground leading-relaxed">
            {message}
          </p>
          <div className="flex flex-col gap-2 pt-2">
            <button
              className={`w-full rounded-md border px-4 py-2 text-xs font-medium transition-colors ${
                loading
                  ? "border-border/40 bg-white/[0.03] text-muted-foreground cursor-not-allowed opacity-50"
                  : "border-red-500/30 bg-red-500/10 text-red-400 hover:bg-red-500/20"
              }`}
              onClick={onConfirm}
              disabled={loading}
            >
              {loading ? loadingText : confirmText}
            </button>
            <button
              className="w-full rounded-md border border-border/70 bg-white/[0.03] px-4 py-2 text-xs text-muted-foreground hover:bg-white/[0.05] hover:text-foreground transition-colors"
              onClick={onClose}
              disabled={loading}
            >
              {cancelText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportConfirmationModal;
